import { ClipboardEvent } from 'react';

import { IconButton, LabeledInput } from 'components/Blocks';
import { SquareMouseIcon, XIcon } from 'components/Icons';

interface BugLinkInputProps {
  value: string;
  setLink: (v: string) => void;
}

function parseURL(text: string) {
  try {
    const url = new URL(text);

    return url;
  } catch {
    return;
  }
}

export function BugLinkInput({ setLink, value }: BugLinkInputProps) {
  const handleLinkPaste = (e: ClipboardEvent<HTMLInputElement>) => {
    const url = parseURL(e.clipboardData.getData('Text'));

    if (!url) return;

    // We will add path and other validations later...
    const isValid = url.host === window.location.host;

    if (!isValid) return;

    setLink(url.href);
  };

  return (
    <div className="relative">
      <LabeledInput
        label={
          <>
            Link
            <IconButton
              size="small"
              className="ml-auto p-0.5"
              tooltipContent="Set link to current page"
              onClick={() => setLink(window.location.href)}
            >
              <SquareMouseIcon size={14} />
            </IconButton>
          </>
        }
        value={value}
        placeholder={'OW Operations link   [Ctrl+V only]'}
        className="pr-8 placeholder:text-xs placeholder:italic"
        onPaste={handleLinkPaste}
      />

      {!!value && (
        <IconButton
          size="small"
          onClick={() => setLink('')}
          className="absolute bottom-1.5 right-1 text-destructive"
        >
          <XIcon size={14} />
        </IconButton>
      )}
    </div>
  );
}
